module.exports = __webpack_public_path__ + "static/media/n00124.6beb2fc3.jpg";